import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { BOX_SHADOWS, FONTS } from "../../constants";
import { stateType, stateTypeF } from "../../state";
import { BoxHeader } from "../Common/BoxHeader";
import { cloudDataType } from "../NLP/textProcessor";
import { CloudChart } from "./CloudChart";

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		container: {
			display: "flex",
			flexDirection: "column",
			width: "100%",
			// backgroundImage: CHART_COLOR,
			boxShadow: BOX_SHADOWS,
			borderRadius: "10px",
			height: "100%",
			overflow: "hidden",
		},
	})
);

type cloudBoxInputType = { state: stateTypeF; isPos: boolean };
export function CloudBox({ state, isPos }: cloudBoxInputType) {
	let classes = useStyles();
	let ndx = state.saveState.sentiment.varSelected;
	let visData = state.saveState.dataset.visualizationData[ndx];

	let title = "";
	let toolTip = "";
	if (isPos) {
		title = "Positive Topics";
		toolTip = "Shows the most common topics in positive articles.";
	} else {
		title = "Negative Topics";
		toolTip = "Shows the most common topics in negative articles.";
	}
	return (
		<div className={classes.container}>
			<BoxHeader
				title={title}
				toolTip={toolTip}
				line={true}
				color="black"
			></BoxHeader>
			<div
				style={{
					marginLeft: "auto",
					marginRight: "20px",
					marginTop: "-10px",
				}}
			></div>
			<div
				style={{
					display: "flex",
					flexDirection: "row",
					margin: "30px",
				}}
			>
				<CloudChart
					state={state}
					visData={visData}
					isPos={isPos}
				></CloudChart>
			</div>
		</div>
	);
}
